module.exports = __webpack_public_path__ + "img/menu03a.880ad8f6.svg";